import { installConfig } from '../constants';
import { INSTALL_VARIANTS } from '../assets/generated/constants-snippet-installation';
import { gid, pickVariant } from '../utils';

// function pickVariant(targetPrice) {
//   return (
//     INSTALL_VARIANTS.find((v) => v.price >= targetPrice) ??
//     INSTALL_VARIANTS[INSTALL_VARIANTS.length - 1]
//   );
// }

const customInstallationProducts = {
  happyHollow: 1200,
  gaga2Go: 740,
};

const priceBrackets = [
  { max: 15999.99, shadeMultiplier: 0.48825, inGroundMultiplier: 0.368, inGroundPrice: 0.5134, surfaceMultiplier: 0.4, surfacePrice: 0.5859 },
  { max: 19999.99, shadeMultiplier: 0.485625, inGroundMultiplier: 0.368, inGroundPrice: 0.5106 },
  { max: 24999.99, shadeMultiplier: 0.4554, inGroundMultiplier: 0.347, inGroundPrice: 0.4789 },
  { max: 29999.99, shadeMultiplier: 0.4392, inGroundMultiplier: 0.336, inGroundPrice: 0.4612 },
  { max: 34999.99, shadeMultiplier: 0.4095, inGroundMultiplier: 0.315, inGroundPrice: 0.43 },
  { max: 39999.99, shadeMultiplier: 0.3801, inGroundMultiplier: 0.294, inGroundPrice: 0.3991 },
  { max: Infinity, shadeMultiplier: 0.35, inGroundMultiplier: 0.273, inGroundPrice: 0.368 },
];

const NET_CLIMBER_INSTALL_TITLES = [
  'Interstellar Incline Net Climber',
  'Constellation Station Net Climber',
  'Wavelength Net Climber',
  'String Theory Net Climber',
  'Tower Carousel',
  'Lunar Leap',
  'Terrestrial Transit Net Climber',
  'Solar Flare Net Climber',
  'Spacewalk Net Course',
  'Mission Ready Net Climber',
  'Combination Manhole Rope Climber',
  'Nebular Net Climber',
  'X-Pyramid',
  'Galactic Quest Net Climber',
  'Monkey Bar Roller Slide',
  'Laola Climbing Structure',
  'Launch Pad Net Climber',
  "Bird's Nest Carousel",
  'Catwalk Adventure Bridge',
  'Celestial Channel Net Climber',
  'Spider Climber',
  'Cosmic Crest Net Climber',
  'Quick Step Climber',
  '3 Feet High Boulder Climber',
  '4 Feet High Boulder Climber',
  'Craggy Crest Climber',
  'Craggy Mantle Climber',
  'Craggy Range Climber',
  "Pirate's Tower",
  "Pirate's Tower Mini",
  "Bird's Nest Tree",
  "Bird's Nest Mini Tree",
  'The Great Pyramid',
  'Project Longshot Playground',
];

const customInstallationItems = {
  'Merry Go Cycle': { baseCost: 790 },
  'Merry Go Rounds': { baseCost: 1250, variants: { "6' Diameter": 1000, "8' Diameter": 1250, "10' Diameter": 1500 } },
  'Pebble Pods': { baseCost: 680 },
  'Single Post Spinner': { baseCost: 360 },
  'Spinner': { baseCost: 360 },
  'Freedom Glider': { baseCost: 2900, variants: { 'Single Bay': 2900, 'Double Bay': 3800 } },
  'ADA_Swing': { baseCost: 1500 },
  '_swing_arch': { baseCost: 1500, variants: { '2': 1500, '4': 2250, '6': 3250, '8': 4250 } },
  '_swing_tire': { baseCost: 1750 },
  '_swing_single_post': { baseCost: 1250, variants: { '1 Bay': 1250, '2 Bay': 2000, '3 Bay': 3000, '4 Bay': 4000 } },
  '_swing_heavy_duty': { baseCost: 1250, variants: { '2 Seats': 1250, '4 Seats': 2000, '6 Seats': 3000, '8 Seats': 4000 } },
  'Commercial Swing Sets': { baseCost: 1250, variants: { '2': 1250, '4': 2000, '6': 3000, '8': 4000 } },
  'Balance Beams': { baseCost: 500 },
  'Activity Panels': { baseCost: 290 },
  'Climbing Tunnel': { baseCost: 360 },
  'Playground riders': { baseCost: 280 },
  'See Saws': { baseCost: 390, variants: { '2 Seats': 390, '4 Seats': 540, '6 Seats': 690, '8 Seats': 840, '12 Seats': 1120 } },
  'Gaga Ball Pit': { baseCost: 640, variants: { '15 Feet': 640, '20 Feet': 740, '26 Feet': 840 } },
  'Funnel Ball Game': { baseCost: 380 },
  'Climbing': { baseCost: 1200 },
  'Park Benches': { baseCost: 250 },
  'Picnic Tables': { baseCost: 360 },
  'Playground Ramps': { baseCost: 25 },
  'Swing Mats': { baseCost: 0 },
};

const borderRatesPerBorder = {
  surface: { cost: 25, price: 35 },
  inGround: { cost: 15, price: 21 },
};
// const borderConfigByCount = {
//   1: { surface: { cost: 25, price: 35 }, inGround: { cost: 15, price: 21 } },
//   10: { surface: { cost: 250, price: 350 }, inGround: { cost: 150, price: 210 } },
//   20: { surface: { cost: 500, price: 700 }, inGround: { cost: 300, price: 420 } },
// };


function parseBorderCount(value) {
  const n = parseInt(String(value ?? '').match(/\d+/)?.[0] ?? '', 10);
  return n === 1 || n === 10 || n === 20 ? n : null;
}

function borderCountFromItem(item) {
  // Most reliable: Shopify variant option (e.g. option1: "Set of 20")
  const fromOption1 = parseBorderCount(item?.option1);
  if (fromOption1 != null) return fromOption1;

  // Fallback: variant title prefix (e.g. "Set of 20 / Black")
  const fromVariantTitle = parseBorderCount(item?.variantTitle);
  if (fromVariantTitle != null) return fromVariantTitle;

  return null;
}

function calculateInstallationCostAndPrice(item, { hasSurfaceMountPlaygroundRef }) {
  const { productType, title, brand, tags, variantTitle, options, compareAtPrice, price, quantity } = item;
  // console.log('item', item);

  let installationCost = 0;
  let installationPrice = 0;
  let hasInstall = false;

  const basePrice = compareAtPrice || price;
  const productPrice = basePrice / 100;

  const calculateShades = () => {
    const shadeLabor = parseFloat(item.sh_ins_lab || 0);
    const shadeMaterials = parseFloat(item.sh_ins_mats || 0);
    const shadeEquipment = parseFloat(item.sh_ins_eqp || 0);

    if (shadeLabor && shadeMaterials && shadeEquipment) {
      installationCost = (shadeLabor + shadeMaterials + shadeEquipment) * quantity;
      const bracket = priceBrackets.find((b) => productPrice <= b.max);
      installationPrice = installationCost + (installationCost * bracket.shadeMultiplier);
      hasInstall = true;
    } else {
      hasInstall = false;
    }
  };

  const calculateLargePlaySystems = () => {
    hasSurfaceMountPlaygroundRef.current = !!(
      options?.some((option) => option.value.includes('Surface')) ||
      variantTitle?.includes('Surface')
    );

    if (item.hasIntegratedShade) {
      hasInstall = false;
    }

    const lineQuantityPrice = productPrice * quantity;
    const bracket = priceBrackets.find((b) => lineQuantityPrice <= b.max);

    if (title === 'Happy Hollow Playground') {
      installationCost = customInstallationProducts.happyHollow * quantity;
      installationPrice = installationCost * installConfig.freestanding_margin;
    } else {
      const hasSurfaceMountMarkup = hasSurfaceMountPlaygroundRef.current && lineQuantityPrice <= 15999.99;
      installationCost = lineQuantityPrice * (hasSurfaceMountMarkup ? bracket.surfaceMultiplier : bracket.inGroundMultiplier);
      installationPrice = lineQuantityPrice * (hasSurfaceMountMarkup ? bracket.surfacePrice : bracket.inGroundPrice);
    }
    hasInstall = true;
  };

  const calculateFreestanding = () => {
    const tagKey = Array.isArray(tags) ? tags.find((tag) => customInstallationItems[tag]) : null;
    const itemConfig = customInstallationItems[tagKey || productType];

    if (!itemConfig) return;

    if (title === 'GaGa2Go Portable GaGa Ball Pit') {
      installationCost = customInstallationProducts.gaga2Go * quantity;
      installationPrice = installationCost * installConfig.freestanding_margin;
      hasInstall = true;
      return;
    }

    if (NET_CLIMBER_INSTALL_TITLES.some((name) => title.includes(name))) {
      installationCost = (price * 0.35) * quantity;
      installationPrice = installationCost * installConfig.freestanding_margin;
      hasInstall = true;
      return;
    }

    const variants = itemConfig.variants;
    const variantKeys = variants ? Object.keys(variants) : [];
    if (variantKeys.length === 0) {
      installationCost = itemConfig.baseCost * quantity;
      installationPrice = installationCost * installConfig.freestanding_margin;
      hasInstall = true;
      return;
    }

    if (!variantTitle) return;

    const variantKey = variantKeys.find((key) => variantTitle.includes(key));
    installationCost = (variantKey ? variants[variantKey] : itemConfig.baseCost) * quantity;
    installationPrice = installationCost * installConfig.freestanding_margin;
    hasInstall = true;
  };

  const calculateRubberMulch = (baseCost) => {
    installationCost = (baseCost * quantity) + installConfig.mulch_equipment_fees;
    installationPrice = installationCost * installConfig.freestanding_margin;
    hasInstall = true;
  };

  const calculatePlasticPlaygroundBorder = () => {
    const borderCount = borderCountFromItem(item);
    if (borderCount == null) return;

    const type = hasSurfaceMountPlaygroundRef.current ? 'surface' : 'inGround';
    installationCost = borderRatesPerBorder[type].cost * borderCount * quantity;
    installationPrice = borderRatesPerBorder[type].price * borderCount * quantity;
    hasInstall = true;
  };

  const doesntRequreInstall = () => {
    installationCost = 0;
    installationPrice = 0;
    hasInstall = true;
  }

  if (productType === 'Shades') {
    calculateShades()
  } else if (productType === 'Large Play Systems' || productType === 'Playground Fitness' || tags?.includes('Hercules') || tags?.includes('Freestanding Custom Install')) {
    calculateLargePlaySystems()
  } else if (tags?.includes('Freestanding Play') || productType === 'Swing Mats' || productType === 'Park Benches' || productType === 'Picnic Tables' || productType === 'Playground Ramps') {
    calculateFreestanding()
  } else if (title.includes('Plastic Playground Border')) {
    calculatePlasticPlaygroundBorder()
  } else if (productType === 'Rubber Mulch' || tags?.includes('Rubber Mulch')) {
    if (title.includes('Playground Rubber Mulch')) {
      calculateRubberMulch(installConfig.ground_smart_base_cost)
    } else if (title.includes('Loose Fill Rubber Mulch')) {
      calculateRubberMulch(installConfig.loose_fill_base_cost)
    }
  } else if (brand?.includes('Playground Surfacing Partners') || brand?.includes('Playground Turf Partners') || brand?.includes('EWF Network')) {
    doesntRequreInstall()
  }

  return { installationCost, installationPrice, hasInstall };
}

export function calculateInstallation(items = [], state) {
  const hasSurfaceMountPlaygroundRef = { current: false };

  const totals = (items ?? []).reduce(
    (acc, item) => {
      const { installationCost, installationPrice, hasInstall } = calculateInstallationCostAndPrice(item, { hasSurfaceMountPlaygroundRef });
      acc.totalInstallationCost += installationCost;
      acc.totalInstallationPrice += installationPrice;
      acc.allHaveInstall = acc.allHaveInstall && hasInstall;
      return acc;
    },
    { totalInstallationCost: 0, totalInstallationPrice: 0, allHaveInstall: true }
  );

  const stateTier =
    Object.values(installConfig.state_tiers).find((t) => t.states.includes(state)) ||
    installConfig.state_tiers.tier_0;
  const stateAdjustment = stateTier ? stateTier.multiple : 1;
  const additionalFee = stateTier.additional_fee || 0;
  const additionalFeePrice = additionalFee * installConfig.freestanding_margin;

  const adjustedCost = (totals.totalInstallationCost * stateAdjustment) + additionalFee;
  const adjustedPrice = (totals.totalInstallationPrice * stateAdjustment) + additionalFeePrice;

  const minCostFloor =
    installConfig.mimimum_installation_cost * stateAdjustment + additionalFee;
  const minPriceFloor =
    installConfig.mimimum_installation_price * stateAdjustment + additionalFeePrice;

  const installationMinimumMet = adjustedCost >= minCostFloor;

  const adjustedTotalCost = Math.max(adjustedCost, minCostFloor).toFixed(2);

  const adjustedTotalPrice = Math.max(adjustedPrice, minPriceFloor).toFixed(2);

  const totalCost = Number(adjustedTotalCost);
  const totalPrice = Number(adjustedTotalPrice);

  // const needsCustomInstallQuote = totals.allHaveInstall === false;
  const allItemsHaveInstall = totals.allHaveInstall;
  const roundedTarget = Math.round(totalPrice || 0);

  // If any item doesn't have an installation calc, force the special "custom install quote"
  // variant (priced at $0.99) so the draft order is still created but flagged for admin.
  const customInstallVariant = INSTALL_VARIANTS.find((v) => Number(v.price) === 0.99);
  const selectedVariant = !allItemsHaveInstall && customInstallVariant ? customInstallVariant : pickVariant(INSTALL_VARIANTS, roundedTarget);
  const selectedPrice = selectedVariant?.price ?? null;
  const discountAmount =
    selectedPrice == null ? null : Math.round(Math.max(0, selectedPrice - roundedTarget));

  return {
    totalInstallationCost: totalCost,
    totalInstallationPrice: totalPrice,
    allItemsHaveInstall: allItemsHaveInstall,
    installVariantGid: selectedVariant?.vId ? gid(selectedVariant.vId) : null,
    installVariantPrice: selectedPrice,
    installDiscountAmount: discountAmount,
    installationMinimumMet,
  };
}

